import { useMutation, useQueryClient } from "react-query";
import makeApiRequest from "services/makeApiRequest";
import apiEndPoints from "services/apiEndPoints";
import { ErrorToast, SuccessToast } from "services/toasterService";

export default function useAddSalaryGrade(closeModal) {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(
        apiEndPoints.SETTINGS_GRADES,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        closeModal();
        queryClient.invalidateQueries("settings-salary-grades");
        queryClient.invalidateQueries("salary_component_data");
        SuccessToast({ text: data?.message });
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
